var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefit6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    transform: "translate(0 0.0483398)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4304 67.0483H83.2604C85.9204 67.0483 88.0804 69.2083 88.0804 71.8683V82.5683H12.6104V71.8683C12.6104 69.2083 14.7704 67.0483 17.4304 67.0483Z",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4206 47.0283H73.2606C75.9206 47.0283 78.0806 49.1883 78.0806 51.8483V67.0483H22.6006V51.8483C22.6006 49.1883 24.7606 47.0283 27.4206 47.0283Z",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1006 72.1182H86.5906",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8405 35.0181H67.8605C70.5205 35.0181 72.6805 37.1781 72.6805 39.8381V47.1381H28.0205V39.8381C28.0205 37.1781 30.1805 35.0181 32.8405 35.0181Z",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1802 38.978H71.5102",
    stroke: "#363636",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0706 21.6882C39.0706 24.0682 36.6906 25.9882 36.6906 25.9882C36.6906 25.9882 34.3105 24.0582 34.3105 21.6882C34.3105 19.3182 36.6906 17.3882 36.6906 17.3882C36.6906 17.3882 39.0706 19.3182 39.0706 21.6882Z",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6904 35.018V26.208",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1804 21.6882C48.1804 24.0682 45.8004 25.9882 45.8004 25.9882C45.8004 25.9882 43.4204 24.0582 43.4204 21.6882C43.4204 19.3182 45.8004 17.3882 45.8004 17.3882C45.8004 17.3882 48.1804 19.3182 48.1804 21.6882Z",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8003 35.018V26.208",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2805 21.6882C57.2805 24.0682 54.9005 25.9882 54.9005 25.9882C54.9005 25.9882 52.5205 24.0582 52.5205 21.6882C52.5205 19.3182 54.9005 17.3882 54.9005 17.3882C54.9005 17.3882 57.2805 19.3182 57.2805 21.6882Z",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9004 35.018V26.208",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3806 21.6882C66.3806 24.0682 64.0006 25.9882 64.0006 25.9882C64.0006 25.9882 61.6206 24.0582 61.6206 21.6882C61.6206 19.3182 64.0006 17.3882 64.0006 17.3882C64.0006 17.3882 66.3806 19.3182 66.3806 21.6882Z",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0005 35.018V26.208",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6206 64.8176C36.9906 66.1576 35.3906 66.7276 34.0506 66.0976C32.7106 65.4676 32.1406 63.8677 32.7706 62.5277C33.4006 61.1877 35.0006 60.6177 36.3406 61.2477C37.6806 61.8777 38.2506 63.4776 37.6206 64.8176Z",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4305 53.4478C31.5705 56.8478 32.2305 60.1078 34.4905 61.9878",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0405 64.8181C51.4105 66.1581 49.8105 66.7281 48.4705 66.0981C47.1305 65.4681 46.5605 63.8681 47.1905 62.5281C47.8205 61.1881 49.4205 60.6181 50.7605 61.2481C52.1005 61.8781 52.6705 63.4781 52.0405 64.8181Z",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3906 62.0479C52.5306 59.2679 53.2206 56.0179 51.9006 53.3979",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3104 63.8379C60.5304 65.2979 61.9004 66.3079 63.3604 66.0879C64.8204 65.8679 65.8304 64.4979 65.6104 63.0379C65.3904 61.5779 64.0204 60.5679 62.5604 60.7879C61.1004 61.0079 60.0904 62.3779 60.3104 63.8379Z",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6205 54.458C68.4705 57.968 66.9204 60.898 64.2104 62.058",
    stroke: "#2766B0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit6);
export default __webpack_public_path__ + "static/media/benefit6.24a19e537dcab78f52edcd7ef242e208.svg";
export { ForwardRef as ReactComponent };